export default __webpack_public_path__ + "static/media/side-pile.ae9e25f9.svg";